import React from "react";
import { Info } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useContent } from "../lib/content";

export default function DisclaimerBanner() {
  const { t } = useI18n();
  const { tc } = useContent();
  return (
    <div
      data-testid="disclaimer-banner"
      className="bg-[#0F1525] border border-[#1E2A3F] px-4 py-3 flex items-start gap-3 text-xs text-[#94A3B8]"
    >
      <Info className="h-4 w-4 mt-0.5 flex-shrink-0 text-[#3B82F6]" strokeWidth={1.5} />
      <p className="leading-relaxed">{tc("disclaimer.full_text", t("footer.disclaimer_full"))}</p>
    </div>
  );
}
